module.exports = __webpack_public_path__ + "img/scene5copy02.a3aa974d.png";